<template>
  <div
    v-if="menuShow"
    style="
      transform: translate(-50%, -50%);
      width: 371px;
      height: 524px;
      z-index: 999;
    "
    class="fixed left-50 top-50 bg-white shadow-xl rounded-xlg overflow-y-scroll py-8 px-5"
  >
    <div style="" class="flex-col h-full overflow-y-scroll">
      <div class="flex-col">
        <div class="text-sm text-neutral-600 font-semibold uppercase">
          {{ section_1?.product?.name }}
        </div>
        <div
          @click="goto('blast')"
          class="text-base text-neutral-400 my-4 ml-6"
        >
          {{ section_1?.product?.oca_blast?.title }}
        </div>
        <div
          @click="goto('interaction')"
          class="text-base text-neutral-400 my-4 ml-6"
        >
          {{ section_1?.product?.oca_interaction?.title }}
        </div>
        <!-- <div
          @click="goto('whatsapp-api')"
          class="text-base text-neutral-400 my-4 ml-6"
        >
          {{ section_1?.product?.oca_whatsapp?.title }}
        </div> -->
        <div
          @click="goto('bot-builder')"
          class="text-base text-neutral-400 my-4 ml-6"
        >
          {{ section_1?.product?.oca_chatbot?.title }}
        </div>
      </div>
      <div class="flex-col">
        <div class="text-sm text-neutral-600 font-semibold uppercase">
          {{ section_1?.solution?.name }}
        </div>
        <div
          @click="goto('ukm')"
          class="text-base text-neutral-400 my-4 ml-6"
        >
          {{ section_1?.solution?.umkm?.title }}
        </div>
        <div
          @click="goto('solutions/enterprise')"
          class="text-base text-neutral-400 my-4 ml-6"
        >
          {{ section_1?.solution?.enterprise?.title }}
        </div>
        <div
          @click="goto('whatsapp-api')"
          class="text-base text-neutral-400 my-4 ml-6"
        >
          {{ section_1?.product?.oca_whatsapp?.title }}
        </div>
      </div>
      <!-- <div class="flex-col">
        <div class="text-sm text-neutral-600 font-semibold uppercase">
          {{ section_1?.pricing?.name }}
        </div>
        <div
          @click="goto('harga')"
          class="text-base text-neutral-400 my-4 ml-6"
        >
          {{ section_1?.pricing?.text }}
        </div>
      </div> -->
      <div class="flex-col">
        <div
          @click="goto('partnership')"
          class="text-sm text-neutral-600 font-semibold uppercase my-4"
        >
          {{ section_1?.partnership?.name }}
        </div>
      </div>
      <div class="flex-col">
        <div class="text-sm text-neutral-600 font-semibold uppercase">
          {{ section_1?.resources?.name }}
        </div>
        <!-- <div
          @click="goto('resources')"
          class="text-base text-neutral-400 my-4 ml-6"
        >
          {{ section_1?.resources?.faq?.title }}
        </div> -->
        <a
          href="https://ocaindonesia.co.id/blog/"
          class="block text-base text-neutral-400 my-4 ml-6"
          >{{ section_1?.resources?.blog?.title }}</a
        >
        <a
          href="https://docs.ocaindonesia.co.id/product-documentation"
          class="block text-base text-neutral-400 my-4 ml-6"
          >{{ section_1?.resources?.documentation?.title }}</a
        >
      </div>
      <div class="flex-col">
        <a
          href="/about-us"
          class="text-sm text-neutral-600 font-semibold uppercase my-4"
          >{{ section_1?.about?.name }}</a
        >
      </div>
      <div class="flex-col">
        <div
          @click="goto('harga')"
          class="text-sm text-neutral-600 font-semibold uppercase my-4"
        >
          {{ section_1?.pricing?.text }}
        </div>
      </div>
      <!-- <div class="flex-col">
        <div
          @click="gotoDashboard()"
          class="text-sm text-neutral-600 font-semibold uppercase my-4"
        >
          {{ section_1?.button_login }}
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { APP_LAYOUT } from "../../app-settings/home";

export default {
  name: "Menubar",
  data: function () {
    return {
      listData: {},
      section_1: {},
      footer: {},
      tabNavbar: {
        product: false,
        solutions: false,
        pricing: false,
        resources: false,
        aboutus: false,
      },
      newsShow: true,
      isMultiLanguage: false,
      currLanguage: localStorage.getItem("lang"),
      konten: {},
      ListNav: {
        EN: [],
        ID: [],
      },
      activeNavbar: "",
    };
  },
  props: {
    menuShow: Boolean,
  },
  mounted() {
    this.listData = APP_LAYOUT;
    if (localStorage.getItem("lang") === "id") {
      this.section_1 = this.listData.header_id;
      this.footer = this.listData.footer_id;
    } else if (localStorage.getItem("lang") === "en") {
      this.section_1 = this.listData.header_eng;
      this.footer = this.listData.footer_eng;
    } else {
      this.section_1 = this.listData.header_id;
      this.footer = this.listData.footer_id;
      localStorage.setItem("lang", "en");
    }
  },
  methods: {
    goto: function (url) {
      window.location.assign(
        `${window.location.protocol}//${window.location.host}/${url}`
      );
    },
    gotoWa() {
      window.open("https://wa.me/6281110691011", "_blank");
    },
    gotoDashboard() {
      window.open("https://sso.ocaindonesia.co.id");
    },
  },
};
</script>
